import { searchState } from '../globals/searchState';
import { doCreateGraphicsItem } from '../util/createItem';
import { logErrorAndShowToast } from '../util/uiError';
import { showCreateGraphicsDialog } from './createItem';
import type { CreateItemHandlerParams } from './createItemDialogRequest';


// Until we have UI for managing graphics, there is no point in showing
// these buttons to end users
export const shouldShowCreateGraphicsButtons = false;

export function showNewGraphicsDialog() {
  showCreateGraphicsDialog(createGraphicsItem);
}

async function createGraphicsItem({ folderId, metadata, analyticConfig, visibleTo, updatableBy }: CreateItemHandlerParams) {
  try {
    const itemId = await doCreateGraphicsItem(searchState, folderId, metadata, analyticConfig, visibleTo, updatableBy);
    console.debug(`Created graphics with ID ${itemId}`);
  } catch(err: unknown) {
    logErrorAndShowToast('Failed to save new graphics', err);
  }
}